import React, { useEffect, useState } from "react";
import HeaderLeft from "./HeaderLeft";
import vedio from "../assets/images/vedio.png";
import { Link } from "react-router-dom";
import DropdownRight from "./DropdownRight";
import { saveAs } from "file-saver";
import DownloadLink from "react-download-link";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { SpinnerCircular } from "spinners-react";

function DownloadSample() {
  let user = localStorage.getItem("user");
  user = JSON.parse(user);
  const token = GetStorage.get("xAuthToken");
  const [loading, setLoading] = useState(false);
  const [sapmeVideo, setSapmeVideo] = useState({});
  const [error, setError] = useState("");
  const [zip, setZip] = useState("");
  const [uploadSpin, setUploadSpin] = useState(false);

  useEffect(() => {
    DownloadSampleVideo();
  }, []);

  const DownloadSampleVideo = async () => {
    setLoading(true);
    setUploadSpin(true);
    http
      .get(`api/common/raw-video?token=${token}`, {
        headers: {
          "Content-Disposition": "attachment",
        },
      })
      .then((res) => {
        console.log("response =======>", res.data);
        setSapmeVideo(res.data);
        setZip(res.data.zip);
        setLoading(false);
        setUploadSpin(false);
      })
      .catch((error) => {
        setLoading(false);
        setUploadSpin(false);

        console.log("error ", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  return (
    <>
      <header>
        <div className="custom_container ">
          <HeaderLeft />
          <div className="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section className="otp_verification custom_hight">
        {Object.keys(sapmeVideo).length === 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            No raw video found
          </div>
        ) : (
          <div className="login_inner">
            <h1 className="mb_30 main_title ">
              {user.data.firstname} {user.data.lastname}
            </h1>
            <p className="mb_40 them_para text-center mx-auto text_limit">
              Please download a sample raw file, and a sample eVO, done
              previously by Argo analyst
            </p>
            <h6 className="sub_title mb_30">Step 1: Download video</h6>
            <p className="instructions mb_30">
            <strong>Directions:</strong> <br />
            Before downloading these files, please download the OnForm and Dropbox apps. In the Dropbox folder, there are five files. Three are examples of what your finished product should look and sound like. Two are raw videos of a swimmer for you to practice with. To export the raw file from Dropbox to OnForm, click the three dots next to the file, choose share, and then select the OnForm app.
          </p>
            {loading ? (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  marginTop: 40,
                  backgroundColor: "#ffffffc2",
                }}
              >
                <SpinnerCircular size="7%" />
              </div>
            ) : (
              <>
                {/* <div className="vedio">
                  <video
                    src={sapmeVideo.url}
                    style={{ width: 400 }}
                    controls
                    download
                  />{" "}
                </div>
                <p className="text-show-file  mt-2">
                  {
                    sapmeVideo.url.split("/")[
                      sapmeVideo.url.split("/").length - 1
                    ]
                  }
                </p> */}
                <div className="btn_wraper">
                  <a
                    style={{ padding: 15 }}
                    className="them_btn mt_40 mb_30"
                    href="https://www.dropbox.com/scl/fo/fpsbflxpk8zkh1d33oqwz/AGabPEdTHpb3MrFIHS--cnI?rlkey=qs4t6u15njs25p42n1lr9xh46&st=bd4s5ngc&dl=0"
                    // href={sapmeVideo.url}
                    download
                  >
                    {uploadSpin ? (
                      <SpinnerCircular className="button-spin" />
                    ) : (
                      "  Download"
                    )}
                  </a>

                  <Link to="/ploadPracticeVideos" state={{ zip: zip }}>
                  {/* <Link to="/downloadSampleEvo" state={{ zip: zip }}> */}
                    <button
                      className="them_btn mt_40 mb_30"
                      style={{ marginLeft: 20 }}
                    >
                      Next
                    </button>
                  </Link>
                </div>
              </>
            )}
          </div>
        )}
      </section>
    </>
  );
}

export default DownloadSample;
